import React, { useMemo } from "react";
import { TipoPrograma } from "../../__enum";
import { useHabilitaCampoPrograma } from "../../hooks/useDisablePrograma";
import { useExisteAnoVigente } from "../../hooks/useExisteAnoVigente";
import { useOrdenarPeriodos } from "../../hooks/useOrdenarPeriodos";
import { getMergedClassNames } from "utils/HTMLUtils";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import Paginacao from "../../components/PaginacaoTable";
import styles from "./index.scss"
import { ListaProps, Periodo } from "../../__types";
import ListaItemCooperativa from "./listaPeriodoItem/cooperativa/ListaItem";
import ListaItemFinancas from "./listaPeriodoItem/financas/ListaItem";
import { ListaItemUniao } from "./listaPeriodoItem/uniao";
interface ListaBaseProps {
    id?: string;
    periodos: Periodo[];
    className?: string;
    paginaAtual: number;
    setPaginaAtual: (pagina: number) => void;
    totalPages: number;
    totalElements: number;
    tipoPrograma: TipoPrograma;
    cabecalhos: string[];
    ListaItemComponent: any;
    onRefresh: () => void;
}

export const ListaBase: React.FC<ListaBaseProps> = ({
    id = '',
    periodos,
    className,
    paginaAtual,
    setPaginaAtual,
    totalPages,
    totalElements,
    tipoPrograma,
    cabecalhos,
    ListaItemComponent,
    onRefresh
}) => {
    const { classeCondicional } = useHabilitaCampoPrograma(tipoPrograma);
    const ordenarPeriodos = useOrdenarPeriodos();
    const existeAnoVigente = useExisteAnoVigente(periodos);

    const periodosOrdenados = useMemo(() => ordenarPeriodos(periodos), [periodos, ordenarPeriodos]);

    const rootClassName = styles.rootClassName;

    return (
        <div className={getMergedClassNames([rootClassName, className || ''])}>
            <Table className={`${rootClassName}-table`}>
                <TableHead>
                    <TableRow>
                        {cabecalhos.map((cabecalho, index) => (
                            <TableCell key={index} className={`${classeCondicional} ${rootClassName}-cell`}>
                                {cabecalho}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {periodosOrdenados.map((periodo) => (
                        <ListaItemComponent
                            key={`${periodo.idEscola}-${periodo.periodo}`}
                            id={id}
                            paginaAtual={paginaAtual}
                            periodo={periodo}
                            desabilitarDuplicar={existeAnoVigente}
                            onRefresh={onRefresh}
                        />
                    ))}
                </TableBody>
            </Table>

            <Paginacao
                totalElements={totalElements}
                paginaAtual={paginaAtual}
                totalPages={totalPages}
                setPaginaAtual={setPaginaAtual}
            />
        </div>
    );
};

export const ListaCooperativaPeriodo = (props: ListaProps) => (
    <ListaBase
        {...props}
        tipoPrograma={TipoPrograma.CooperativaEscolar}
        cabecalhos={['Anos', 'Qtde Colaboradores', 'Professores(as) Orientadores(as)', 'Qtde Alunos', 'Ações']}
        ListaItemComponent={ListaItemCooperativa}
    />
);

export const ListaFinancasPeriodo = (props: ListaProps) => (
    <ListaBase
        {...props}
        tipoPrograma={TipoPrograma.FinancasNaMochila}
        cabecalhos={['Anos', 'Qtde Colaboradores', 'Qtde Professores', 'Qtde Alunos', 'Ações']}
        ListaItemComponent={ListaItemFinancas}
    />
);

export const ListaUniaoFazAVidaPeriodo = (props: ListaProps) => (
    <ListaBase
        {...props}
        tipoPrograma={TipoPrograma.UniaoFazAVida}
        cabecalhos={['Anos', 'Qtde Colaboradores', 'Qtde Professores', 'Qtde Alunos', 'Ações']}
        ListaItemComponent={ListaItemUniao}
    />
);